module.exports = __webpack_public_path__ + "img/904.e477c89e.gif";